/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Applications_Notes_SavedInputs */

const en_applications_notes_saved = /** @type {(inputs: Applications_Notes_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes saved`)
};

const de_applications_notes_saved = /** @type {(inputs: Applications_Notes_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notizen gespeichert`)
};

const fr_applications_notes_saved = /** @type {(inputs: Applications_Notes_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes sauvegardées`)
};

const es_applications_notes_saved = /** @type {(inputs: Applications_Notes_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notas guardadas`)
};

const it_applications_notes_saved = /** @type {(inputs: Applications_Notes_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note salvate`)
};

const nl_applications_notes_saved = /** @type {(inputs: Applications_Notes_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notities opgeslagen`)
};

const pl_applications_notes_saved = /** @type {(inputs: Applications_Notes_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notatki zapisane`)
};

const fi_applications_notes_saved = /** @type {(inputs: Applications_Notes_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muistiinpanot tallennettu`)
};

const da_applications_notes_saved = /** @type {(inputs: Applications_Notes_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noter gemt`)
};

const sv_applications_notes_saved = /** @type {(inputs: Applications_Notes_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anteckningar sparade`)
};

/**
* | output |
* | --- |
* | "Notes saved" |
*
* @param {Applications_Notes_SavedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const applications_notes_saved = /** @type {((inputs?: Applications_Notes_SavedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Applications_Notes_SavedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_applications_notes_saved(inputs)
	if (locale === "fr") return fr_applications_notes_saved(inputs)
	if (locale === "es") return es_applications_notes_saved(inputs)
	if (locale === "it") return it_applications_notes_saved(inputs)
	if (locale === "nl") return nl_applications_notes_saved(inputs)
	if (locale === "pl") return pl_applications_notes_saved(inputs)
	if (locale === "fi") return fi_applications_notes_saved(inputs)
	if (locale === "da") return da_applications_notes_saved(inputs)
	if (locale === "sv") return sv_applications_notes_saved(inputs)
	return en_applications_notes_saved(inputs)
});